export const dateToMs = (date: any, endDate?: any) => {
  if (!date) { return null }
  if (endDate) {
    let eDate = new Date(date);
    return +eDate.setHours(23, 59, 59)
  } else {
    return +new Date(date);
  }
}


export const randomName = () => {
  return String(new Date().getTime());
};


export const timeWithDateMs = (time: any, date?: any) => {
  if (!time || time.length > 15) { return time; }
  if (date) {
    let formatDate = new Date(date);
    formatDate.setHours(new Date(time).getHours());
    formatDate.setMinutes(new Date(time).getMinutes());
    if (formatDate instanceof Date) {
      return + (new Date(formatDate.toUTCString())).setSeconds(0, 0);
    }
  }
}
export function dataURLtoFile(dataurl: any, filename?, calback?) {
  filename = (filename ? filename : filename = new Date().getTime() + ".png");
  let arr = dataurl.split(","),
    mime = arr[0].match(/:(.*?);/)[1],
    bstr = atob(arr[1]),
    n = bstr.length,
    u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  const file = new File([u8arr], filename, { type: mime });
  calback(file);
}

export const isObjEmpty = (obj: any) => {
  for (var key in obj) {
    if (obj.hasOwnProperty(key)) return false;
  }
  return true;
}

export const titleCase = (str: string) => {
  if (str) {
    return str.toLowerCase().split(' ').map((word) => {
      return (word.charAt(0).toUpperCase() + word.slice(1));
    }).join(' ');
  } else {
    return '';
  }
}

export const isReadyToEndClass = (time: number, countDownTime: number) => {
  /**
   * @15=> 15 Min, @60=>60 Min By Default
   */
  switch (countDownTime) {
    case 15:
      if ((time - Date.now()) <= 15 * 60 * 1000) {
        return false;
      } else {
        return true;
      }
    default:
      if ((time - Date.now()) <= 60 * 60 * 1000) {
        return false;
      } else {
        return true;
      }
  }

}

export const formatClassType = (value: string) => {
  switch (value) {
    case 'GROUPX':
      return 'Group X';
    default:
      return 'Yoga';
  }
}

export const checkSpaceAtStartEnd = (value: string) => {
  if (/^\s+|\s+$/g.test(value)) {
    return true;
  } else {
    return false;
  }
}



export function countFilter(data) {
  let count = 0;
  for (const k in data) {
    if (data[k] != null && data[k] != '') {
      ++count;
    }
  }
  return count;

}

export function removeEmptyKeysInObject(obj){
    let newObj = {};
    Object.keys(obj).forEach((prop) => {
      if (obj[prop]) { newObj[prop] = obj[prop]; }
    });
    return newObj;
};
